module.exports = __webpack_public_path__ + "img/block_bg_6_1_1.cfb105b0.png";